import { RiSearchLine } from "@remixicon/react";
import classNames from "classnames";
import React, {
    HTMLAttributes, ReactElement,
} from "react";
import FormGroup from "../../form-group/FormGroup";
import Styles from "../Table.module.scss";
import useTableData, { ContainsId } from "../base";

export interface TableControlsSearchProps<T extends ContainsId> extends HTMLAttributes<HTMLInputElement> {
    search: (query: string, item: T) => boolean | undefined | null;
}

const QUERY_KEY = "q";

const TableControlsSearch = React.forwardRef(<T extends ContainsId>(
    args: TableControlsSearchProps<T>,
    ref: React.ForwardedRef<HTMLInputElement>,
): ReactElement => {
    const {
        className,
        search,
        ...rest
    } = args;

    const data = useTableData<T>();
    const [value, setValue] = data.useFilter<string>({
        filter: (item, searching) => {
            const lower = searching.toLowerCase().trim();
            return lower ? search(lower, item as T) : true;
        },
        serialize: query => query,
        deserialize: query => query as string,
        filterKey: QUERY_KEY,
        defaultValue: "",
        dependencies: [],
    });

    return (
        <FormGroup
            type="search"
            prefixIcon={<RiSearchLine />}
            placeholder="Search..."
            aria-label="Search"
            autoFocus
            size="filter"
            value={value}
            className={classNames(Styles["action-search"], className)}
            ref={ref}
            {...rest}
            onChange={event => {
                setValue(event.target.value);
            }}
        />
    );
});

TableControlsSearch.defaultProps = {

};

export type Type<T extends ContainsId> = (
    props: TableControlsSearchProps<T> & { ref?: React.ForwardedRef<HTMLInputElement> }
) => ReactElement;

export default TableControlsSearch as Type<ContainsId>;
